import React from "react";
import '../assets/styles/Footer.scss';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-title">TAI–CLAIM–ICR Collaboration</p>
        <p className="footer-meta">University of Luxembourg × Luxembourg Institute of Science and Technology</p>
      </div>
    </footer>
  );
}

export default Footer;